import * as React from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
	startAdornment?: React.ReactNode; // Para íconos o texto al inicio
	endAdornment?: React.ReactNode; // Para íconos o texto al final
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, startAdornment, endAdornment, ...props }, ref) => {
		return (
			<div className="relative flex items-center w-full">
				{/* Ícono o texto al inicio */}
				{startAdornment && (
					<div className="absolute left-3 flex items-center pointer-events-none">
						{startAdornment}
					</div>
				)}
				<input
					type={type}
					className={cn(
						'flex h-9 w-full rounded-md border border-light-input-border dark:border-dark-input-border bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-light-input-placeholder dark:placeholder:text-dark-input-placeholder focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-light-input-border dark:focus-visible:ring-dark-input-border disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
						startAdornment && 'pl-10', // Ajusta el padding si hay un ícono al inicio
						endAdornment && 'pr-10', // Ajusta el padding si hay un ícono al final
						className,
					)}
					ref={ref}
					{...props}
				/>
				{/* Ícono o texto al final */}
				{endAdornment && (
					<div className="absolute right-3 flex items-center pointer-events-none">
						{endAdornment}
					</div>
				)}
			</div>
		);
	},
);

Input.displayName = 'Input';

export { Input };
